"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blocksToInputData = (blocks) => {
    if (!blocks) {
        return [];
    }
    return blocks.map((block) => {
        return {
            adContextIds: block.type === 'field' &&
                block.fieldType === 'ad' &&
                block.ad &&
                block.adContexts
                ? block.adContexts
                    .map(c => c.id)
                    .filter(cid => cid !== null && cid !== undefined)
                : [],
            adId: block.type === 'field' && block.fieldType === 'ad' && block.ad
                ? block.ad.id || undefined
                : undefined,
            attrKeys: block.attrKeys || [],
            attrs: block.attrs || {},
            basicProcessing: block.fieldTypes && block.fieldTypes.includes('html')
                ? block.basicProcessing === true
                : undefined,
            childBlocks: block.childBlocks
                ? exports.blocksToInputData(block.childBlocks)
                : [],
            clientId: block.clientId,
            cloneOfId: undefined,
            contentFeedId: block.contentFeed ? block.contentFeed.id : undefined,
            contentFieldKey: block.contentFieldKey || undefined,
            contentItem: block.contentItem,
            contentSlotNumber: typeof block.contentSlotNumber === 'number'
                ? block.contentSlotNumber
                : undefined,
            contentStr: block.contentStr,
            datetimeFormat: block.fieldTypes && block.fieldTypes.includes('datetime')
                ? block.datetimeFormat
                : undefined,
            fieldType: block.type === 'field' ? block.fieldType || undefined : undefined,
            hidden: block.hideable ? block.hidden === true : undefined,
            hideable: !!block.hideable,
            id: block.id || undefined,
            lockable: block.lockable === true,
            locked: block.lockable === true && block.locked === true,
            name: block.name,
            order: block.order,
            repeatOfId: block.repeatOf ? block.repeatOf.id : undefined,
            selectedTargets: block.selectedTargets || [],
            socialProvider: block.socialProvider,
            type: block.type,
            usingRichContentEditor: block.usingRichContentEditor === true,
        };
    });
};
//# sourceMappingURL=blocksToInputData.js.map